module.exports = __webpack_public_path__ + "static/media/oval.23ff2c95.svg";